import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import SurveyService from "../../src/Services/Survey.service";
const SurveyLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "displayName",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => any' is not assignable to type '(ids: string[]) => Promise<Survey[]>'.
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2339 - Property 'findByIds' does not exist on type 'typeof SurveyService'.
            return SurveyService.findByIds(ids);
        },
        fetchOptions: (search) => {
            // @ts-expect-error - TS2339 - Property 'searchAll' does not exist on type 'typeof SurveyService'.
            return SurveyService.searchAll(search);
        },
        optionRenderer: function optionRenderer(survey) {
            return _jsx("span", { children: survey.displayName });
        },
    });
};
export default SurveyLookup;
